import { render, staticRenderFns } from "./dogColorful.vue?vue&type=template&id=05446c50"
import script from "./dogColorful.vue?vue&type=script&lang=js"
export * from "./dogColorful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports